export const PERSON_ATTACH_OBJECT = 'PERSON';
export const INTERNSHIP_ATTACH_OBJECT = 'INTERNSHIP';
export const PERSON_RECORD_ATTACH_OBJECT = 'PERSON_RECORD';
export const ATTACHMENT_MAX_FILE_SIZE = 52428800; // 50 Mb in bytes
export const ATTACHMENT_ACCEPTED_EXTENSIONS = [
  '.zip',
  '.rar',
  '.tar',
  '.txt',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.pdf',
  '.wps',
  '.csv',
  '.png',
  '.svg',
  '.ico',
  '.gif',
  '.bmp',
  '.tiff',
  '.pcx',
  '.heic',
  '.heif',
  '.wdp',
  '.webp',
  '.avif',
  '.jpg',
  '.jpeg',
  '.jpg2',
  '.jfif',
  '.jxr',
  '.jpe',
  '.j2p',
  '.hdp',
  '.j2k',
  '.jpf',
  '.j2c',
  '.jpf',
  '.jpm',
  '.jpx',
  '.psd',
  '.jpc',
];
export const ATTACHMENT_ACCEPTED_MIME_FORMATS = [
  // archives
  'application/vnd.rar',
  'application/x-tar',
  'application/zip',
  'application/x-zip-compressed',
  // documents
  'application/msword',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.ms-works',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/csv',
  'text/plain',
  // images
  'image/x-icon',
  'image/avif',
  'image/bmp',
  'image/gif',
  'image/heic',
  'image/heif',
  'image/j2c',
  'image/j2k',
  'image/j2p',
  'image/jp2',
  'image/jpe',
  'image/jpeg',
  'image/jpm',
  'image/jpx',
  'image/jxr',
  'image/jpc',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/vnd.adobe.photoshop',
  'image/vnd.microsoft.icon',
  'image/vnd.ms-photo',
  'image/vnd.zbrush.pcx',
  'image/webp',
  'image/x-jpf',
  'image/x-jp2-codestream',
];
